<!-- Change Event Section -->
<h5 class="text-white">{{ 'loaded.tickets.page.title' | translate }}</h5>
<p class="text-white font-size-14">{{ 'loaded.tickets.page.desc' | translate }}</p>

@if (loadingEvents()) {
  <div class="card placeholder-card bg-secondary" aria-hidden="true">
    <div class="card-body p-0">
      <div class="card-text placeholder-glow bg-grey">
        <span class="placeholder col-12"></span>
      </div>
    </div>
  </div>
} @else if (selectedEvent()) {
  <fgb-selected-event></fgb-selected-event>

  <fgb-tickets></fgb-tickets>
} @else {
  <div class="border border-grey bg-secondary rounded">
    <div class="font-size-14 events-placeholder text-white">
      {{ 'no.events.placeholder' | translate }}
    </div>
  </div>
}
